exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/user/sign-in/sign-in.component.css
// module id = ../../../../../src/app/user/sign-in/sign-in.component.css
// module chunks = main